// Generated by https://quicktype.io

export class GiftBalanceResponseDTO {
	responseOrigin: string;
	cmdStatus: string;
	textResponse: string;
	tranCode: string;
	operatorID: string;
	acctNo: string;
	balance: number;

	public constructor(init?: Partial<GiftBalanceResponseDTO>) {
		Object.assign(this, init);
	}
}

export class GiftProcessedDTO {
	accountNumber: string;
	appliedAmount: number;
	balanceAmount: number;

	public constructor(init?: Partial<GiftProcessedDTO>) {
		Object.assign(this, init);
	}
}
